import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { Analytics } from '@vercel/analytics/react'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  useHistory
} from 'react-router-dom'
import Cookies from 'js-cookie';
const showWebAlerts = process.env.REACT_APP_SHOW_WEB_ALERTS === 'true';

import './style.css'
import PageNotFound from './views/page-not-found'
import Home from './views/home'
import LendMeATenor from './views/lend-me-a-tenor'
import TheWeddingSinger from './views/theweddingsinger'
import AroundTheWorld from './views/around-the-world'
import WebAlerts from './components/web-alerts'
import ScrollToTop from './components/scroll-to-top'
import Docs from './views/documentation'
import Contact from './views/contact'
import Commands from './views/commands'
import PrivacyPolicy from './views/privacy'
import TermsOfService from './views/tos'
import { Mosaic, ThreeDot } from 'react-loading-indicators'
import Dashboard from './views/dashboard';
import axios from 'axios';

const DashboardSync = () => {
  useEffect(() => {
    fetch('https://oauth2.daiki-bot.xyz/dashboard/check-session', {
      method: 'GET',
      credentials: 'include' // ✅ Send cookies with request
    }).then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log("✅ Session Valid");
          window.location.href = "/dashboard"; // ✅ Redirect to actual dashboard
        } else {
          console.warn("❌ Session Invalid, redirecting...");
          window.location.href = 'https://oauth2.daiki-bot.xyz/auth';
        }
      }).catch(error => {
        console.error("❌ Error checking session:", error);
        window.location.href = 'https://oauth2.daiki-bot.xyz/auth';
      });
  }, []);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%', // Full viewport height
      width: '100%',  // Full viewport width
      marginTop: '100px',
    }}>
      <ThreeDot variant="bounce" color={["#6141ac", "#233dff", "#6845ba", "#3850ff"]} size="large" text="" textColor="" />
    </div>
  );
};

const DashboardLogout = () => {
  useEffect(() => {
    const cookieNames = document.cookie
      ? document.cookie.split(';').map((cookie) => cookie.split('=')[0].trim()).filter(Boolean)
      : []
    const hostname = window.location.hostname
    const rootDomain = hostname.split('.').slice(-2).join('.')
    const domains = Array.from(new Set([
      undefined,
      hostname,
      `.${hostname}`,
      rootDomain,
      `.${rootDomain}`,
      '.daiki-bot.xyz',
    ].filter((domain) => domain && domain !== '.localhost')))
    const paths = Array.from(new Set(['/', window.location.pathname]))

    cookieNames.forEach((name) => {
      paths.forEach((path) => {
        Cookies.remove(name, { path })

        domains.forEach((domain) => {
          Cookies.remove(name, { path, domain })
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; domain=${domain}`
        })

        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`
      })
    })

    localStorage.removeItem('discord.oauth2')
    sessionStorage.clear()

    const redirectTimer = setTimeout(() => {
      window.location.replace('https://oauth2.daiki-bot.xyz/auth/logout')
    }, 250)

    return () => clearTimeout(redirectTimer)
  }, [])

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
      marginTop: '100px',
    }}>
      <ThreeDot variant="bounce" color={["#6141ac", "#233dff", "#6845ba", "#3850ff"]} size="large" text="" textColor="" />
    </div>
  )
}

/* const DashboardSync = () => {
  const history = useHistory();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token') || localStorage.getItem('discord.oauth2');

    if (!token) {
      console.warn("❌ No token found, redirecting...");
      window.location.href = 'https://oauth2.daiki-bot.xyz/auth';
      return;
    }

    // ✅ Validate token with backend
    fetch(`https://oauth2.daiki-bot.xyz/dashboard/check-session?token=${token}`, {
      method: 'GET',
      credentials: 'include'
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log("✅ Token is valid:", token);
          localStorage.setItem('discord.oauth2', token);
          history.push('/');
        } else {
          console.warn("❌ Invalid token, redirecting...");
          localStorage.removeItem('discord.oauth2');
          window.location.href = 'https://oauth2.daiki-bot.xyz/auth';
        }
      })
      .catch(error => {
        console.error("❌ Error checking session:", error);
        window.location.href = 'https://oauth2.daiki-bot.xyz/auth';
      });

  }, [history]);

  return <p>Syncing session, please wait...</p>;
}; */

const dashboardViews = require.context('./views/dashboard', false, /\.js$/);

const dashboardRoutes = dashboardViews.keys().map(path => {
  const Component = dashboardViews(path).default;
  const routePath = `/dashboard/${path.replace('./', '').replace('.js', '').toLowerCase()}`;
  return <Route key={routePath} exact path={routePath} component={Component} />;
});

const App = () => {
  return (
    <Router>
      {showWebAlerts && <WebAlerts />}
      <ScrollToTop />
      <Switch>

        {/* Main Website Pages */}
        {/* Main Website Pages */}
        <Route component={Home} exact path="/" />
        <Route component={Home} exact path="/home" />
        <Redirect exact from="/documentation" to="/docs" />
        <Route component={Docs} exact path="/docs" />
        <Route component={Dashboard} exact path="/dashboard" />
        <Route component={Commands} exact path="/commands" />
        <Route component={Contact} exact path='/contact' />

        <Route component={DashboardSync} exact path="/dashboard-sync" />
        <Route component={DashboardLogout} exact path="/dashboard/logout" />
        <Route component={LendMeATenor} exact path="/lendmeatenor" />
        <Route component={TheWeddingSinger} exact path="/theweddingsinger" />
        <Route component={AroundTheWorld} exact path="/aroundtheworld" />
        <Route component={PrivacyPolicy} exact path="/privacy" />
        <Redirect exact from="/privacy-policy" to="/privacy" />
        <Route component={TermsOfService} exact path="/tos" />
        <Redirect exact from="/terms-of-service" to="/tos" />
        {dashboardRoutes}
        {/* <Route component={Status} exact path={"/status"} /> */}
        {/* <Route component={Staff} exact path="/staff" /> */}
        {/*AED CLASS <Route path="/requests" component={() => {
          window.location.href = "https://forms.gle/3R5XF9RYWy2Wnx3Y7"
        }} /> */}
        <Route path='/status' component={() => {
          window.location.href = 'https://status.daiki-bot.xyz';
          return null;
        }} />
        <Route path='/staff' component={() => {
          window.location.href = 'https://admin.dashboard.daiki-bot.xyz';
          return null;
        }} />
        <Route path='/invite' component={() => {
          window.location.href = 'https://top.gg/px/projects/200440790319063040/invite';
          return null;
        }} />
        <Route path='/support' component={() => {
          window.location.href = 'https://discord.com/invite/nWUB8RNB72';
          return null;
        }} />
        <Route path='/top/vote' component={() => {
          window.location.href = 'https://top.gg/bot/839287174482362438/vote'
        }} />
        <Route path='/top/main' component={() => {
          window.location.href = 'https://top.gg/bot/839287174482362438'
        }} />
        <Route path='/partners/contact/bruton-woodworks' component={() => {
          window.location.href = 'https://brutonwoodworks.com/contact'
        }} />
        <Route component={PageNotFound} path="**" />
      </Switch>
      <Analytics />
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
